import { connect } from 'react-redux'
import { withHandlers, compose } from 'recompose'
import { goBack, push } from 'connected-react-router'
import { HOME } from 'constant'
import NavigationBack from './NavigationBack'

// TODO: Try to improve the handleNavigationBack function
const withNavigation = withHandlers({
  handleNavigationBack: ({ location: { key }, goBack, push }) => () => {
    key ? goBack() : push(HOME)
  }
})

const mapStateToProps = ({ router: { location }}) => ({ location })

export default compose(
  connect(mapStateToProps, { goBack, push }),
  withNavigation
)(NavigationBack)
